import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';

/**
 * The standalone /user-activity-logs/:id page has been retired: the app-access log
 * (New Open / Resume, from `user_app_access_log`) is now the "App access" tab on
 * User 360. Old links and bookmarks land on that tab instead of 404-ing.
 *
 * `event_type` and any window carry through; the old page's list-only `page`/`limit`
 * params are dropped — the tab paginates on its own.
 */
const AppAccessLogRedirect = () => {
  const { id } = useParams();
  const { search } = useLocation();
  const src = new URLSearchParams(search);
  const params = new URLSearchParams({ tab: 'app-access' });
  ['event_type', 'from_date', 'to_date'].forEach((key) => {
    const value = src.get(key);
    if (value) params.set(key, value);
  });
  return <Navigate replace to={`/user-detail/${id || ''}?${params.toString()}`} />;
};

export default AppAccessLogRedirect;
